import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "treatment-register-cog",
        path: "/treatment-register-cog",
        component: () => import("./components/CogenteRegisterHomeTile.vue"),
        props: { tileId: "cogente-register-home-tile", registerType: "cogente" },
        meta: {
            navbarItems: [
                { component: "farm-select-nav-bar-item", props: { isRequired: true } },
                "campaign-select-nav-bar-item"
            ]
        }
    },
    {
        name: "treatment-register-dpi",
        path: "/treatment-register-dpi",
        component: () => import("./components/DpiRegisterHomeTile.vue"),
        props: { tileId: "dpi-register-home-tile", registerType: "dpi" },
        meta: {
            navbarItems: [
                { component: "farm-select-nav-bar-item", props: { isRequired: true } },
                "campaign-select-nav-bar-item"
            ]
        }
    },
    {
        name: "treatment-registry-utilizzazioni",
        path: "/treatment-registry-utilizzazioni",
        component: () => import("./components/UtilRegisterHomeTile.vue"),
        props: { tileId: "util-register-home-tile", registerType: "UTILIZZAZIONI" },
        meta: {
            navbarItems: [
                { component: "farm-select-nav-bar-item", props: { isRequired: true } },
                "campaign-select-nav-bar-item"
            ]
        }
    },
    {
        name: "treatment-register-detail",
        path: "/treatment-register-detail",
        component: () => import("./components/TreatmentDraftDetailContainer.vue"),
        props: { tileId: "Modifica il registro" },
        meta: {
            navbarItems: [
                { component: "farm-select-nav-bar-item", props: { isRequired: true } },
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "plot-group-selection-nav-bar-item",
                "crop-selection-nav-bar-item",
            ]
        }
    }
];

export default routes;
